import Routes from '../components/views/tripRoute/tripRoute.vue'
import RouteCreate from '../components/views/tripRoute/RouteCreate.vue'
import RouteDetail from '../components/views/tripRoute/RouteDetail.vue'

const routes = [{
        path: 'routes',
        component: Routes,
        name: 'Route',
        meta: {
            description: 'List of Think Gas Routes',
            title: 'Routes',
            requiresAuth: true
        }
    },

    {
        path: 'routes/create',
        component: RouteCreate,
        name: 'RouteCreate',
        meta: {
            description: 'Add a new Route',
            title: 'Add Route',
            requiresAuth: true
        }
    },
    {
        path: '/routes/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'RouteCreate' }) : next()
        },
        component: RouteDetail,
        name: 'RouteDetail',
        meta: {
            description: 'Details for the selected Route',
            title: 'Update Route',
            requiresAuth: true
        }
    },
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/tripRoute.route.js